<template>
<div></div>
</template>

<script>
  import AiDemoDataMgrMixin from "@/mixin/AiDemoDataMgr";

  export default {
    mixins: [AiDemoDataMgrMixin],
    data() {
      return {
        models: []
      }
    }
  }
</script>
